module.exports = __webpack_public_path__ + "static/media/fvs_valve1_95.97604bf4.jpg";